import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import FieldGenericSelect from '../FieldGenericSelect';
import FieldInput from '../FieldInput';

const StyledWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${(props) => (typeof props.margin === 'number' ? `padding: ${props.margin}px;` : '')}
`;

class TableDropdownField extends React.PureComponent {

  static propTypes = {

    fieldId: PropTypes.string,
    fieldIdentifier: PropTypes.string,
    fieldPositionId: PropTypes.string,
    fieldMode: PropTypes.string,
    fieldPresentationMode: PropTypes.string,
    pageLayoutMode: PropTypes.string,

    type: PropTypes.string,
    value: PropTypes.array,
    cellValue: PropTypes.string,
    disabled: PropTypes.bool,
    options: PropTypes.array,
    tabIndex: PropTypes.number,

    //SDK Styles
    primaryColor: PropTypes.string,

    //Field style
    fontSize: PropTypes.number,
    fontColor: PropTypes.string,
    fontStyle: PropTypes.string,
    fontWeight: PropTypes.string,
    textAlign: PropTypes.string,
    textTransform: PropTypes.string,
    textDecoration: PropTypes.string,
    textOverflow: PropTypes.string,
    borderColor: PropTypes.string,
    borderRadius: PropTypes.number,
    borderWidth: PropTypes.number,
    backgroundColor: PropTypes.string,
    padding: PropTypes.number,
    margin: PropTypes.number,

    //Action handlers
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,

  }

  render() {

    const {

      type,

      fieldId,
      fieldIdentifier,
      fieldPositionId,

      cellValue,
      disabled,
      options,
      tabIndex,

      //Field style
      primaryColor,
      fontSize,
      fontColor,
      fontStyle,
      fontWeight,
      textAlign,
      textTransform,
      textDecoration,
      textOverflow,
      borderColor,
      borderRadius,
      borderWidth,
      backgroundColor,
      padding,
      margin,

      //Action handlers
      onFocus,
      onBlur,

      tableColumns,
      rowOrder,
      rowIndex,
      column,
      fieldMode,
      fieldPresentationMode,
      pageLayoutMode
    } = this.props;

    const tableCellColumn = tableColumns && tableColumns.length > 0 ? tableColumns.find((item) => item._id === column) : {};

    const tableCellRowId = rowOrder && rowOrder.length > 0 ? rowOrder[rowIndex] : '';

    const tableCellColumnIdentifier = tableCellColumn && Object.keys(tableCellColumn).length > 0 ? tableCellColumn.identifier : '';

    let displayFieldNode = (
      <FieldGenericSelect
        data-testid={`${fieldPositionId}-dropdown-generic-field`}
        tabIndex={tabIndex}
        {...{

          type,
          disabled,
          options,
          value: cellValue,

          primaryColor,
          fontSize,
          fontColor,
          fontStyle,
          fontWeight,
          textAlign,
          textTransform,
          textDecoration,
          textOverflow,
          borderColor,
          borderRadius,
          borderWidth,
          backgroundColor,
          padding,

        }}
        onChange={(e) => {
          const nextValue = e.target.value;
          if (!disabled && nextValue !== cellValue) this.handleCellChange(nextValue);
        }}
        onFocus={(e) => {
          if (!disabled && onFocus) onFocus(fieldId, fieldIdentifier, fieldPositionId, { blur: () => { e.target.blur(); } }, tableCellRowId, column, tableCellColumnIdentifier);
        }}
        onBlur={() => {
          if (!disabled && onBlur) onBlur(fieldId, fieldIdentifier, fieldPositionId, {}, tableCellRowId, column, tableCellColumnIdentifier);
        }}
      />
    );

    return (
      <StyledWrapper {...{ margin }}>
        {displayFieldNode}
      </StyledWrapper>
    );
  }

  handleCellChange = (nextCellValue) => {

    const { onChange, rowId, column, value, fieldId, fieldIdentifier, fieldPositionId } = this.props;

    const nextValue = [...value];
    const targetRowIndex = value.findIndex((row) => row._id === rowId);

    const nextRow = { ...nextValue[targetRowIndex] };

    /**<----------NOTICE---------------->
    * onChange will only be triggered if the row and column associated
    * with the table cell is undeleted
    */
    if (nextRow && nextRow._id) {

      nextRow.cells = { ...nextRow.cells, [column]: nextCellValue };

      nextValue[targetRowIndex] = nextRow;

      if (onChange) onChange(fieldId, fieldIdentifier, fieldPositionId, nextValue);

    }

  }
}

export default TableDropdownField;
